// src/lib/meta.js

function initializeMeta(metaId = '389066024760021') {
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'));
    window.fbq('set', 'autoConfig', false, metaId);
    window.fbq('init', metaId);
    window.fbq('set', 'autoConfig', false, metaId);
    window.fbq('track', 'PageView');
    console.log("meta initialize");
}
function initializeMeta2(metaId = '763544197375654') {
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'));
    console.log("meta initialize 2");
}
function eventMeta(metaId = '389066024760021', track) {
    initializeMeta(metaId);
    window.fbq('track', track);
    console.log("event tracking meta");
}

function trackCustom(metaId = '763544197375654') {
    initializeMeta2(metaId);
    // setTimeout(() => {
        window.fbq('set', 'autoConfig', false, metaId);
        window.fbq('init', metaId);
        window.fbq('trackCustom', 'lead_submit');
        console.log("META TRACK CUSTOM EVENT - lead_submit >l< " + metaId);
    // }, 1000);
}


export { initializeMeta, eventMeta, trackCustom };
